const routes = [
    {
        path: "/coop/ban-list",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
